// extracted by mini-css-extract-plugin
export var eyebrow = "VisualBelowHeadline-module--eyebrow--cf585";
export var leftColumn = "VisualBelowHeadline-module--left-column--8f896";
export var thumbnail = "VisualBelowHeadline-module--thumbnail--83354";
export var videoTrigger = "VisualBelowHeadline-module--video-trigger--26d6f";
export var visualBelowHeadline = "VisualBelowHeadline-module--visual-below-headline--d2c00";